<template>
	<div style="width: 350px">
		<el-form
			label-position="right"
			ref="baseinfo"
			label-width="80px"
			:model="userInfoForm"
			size="small"
			style="width: 360px"
		>
			<el-form-item label="我的身份:">
				{{ getUserTypeName(userInfoForm.userType) }}
			</el-form-item>
			<el-form-item label="登录账号:">
				{{ userInfoForm.account }}
				<el-button type="text" @click="changePwd">修改密码</el-button>
			</el-form-item>
			<el-form-item label="用户昵称:">
				{{ nickName }}
				<el-button type="text" @click="changeNickName">修改</el-button>
			</el-form-item>
			<el-form-item label="用户邮箱:">
				{{ email }}
				<el-button
					v-if="!email"
					type="text"
					@click="bindEmail"
					>绑定邮箱</el-button
				>
				<el-button v-else type="text" @click="bindEmail"
					>修改邮箱</el-button
				>
				<modifyEmail ref="modifyEmail" />
			</el-form-item>
			<el-form-item label="手机号:">
				{{ phoneNumber }}
				<el-button
					v-if="!phoneNumber"
					type="text"
					@click="bindPhone"
					>绑定手机</el-button
				>
				<el-button v-else type="text" @click="bindPhone"
					>修改手机</el-button
				>
				<modifyPhone ref="modifyPhone" />
			</el-form-item>
			<el-form-item label="MFA设置:" v-if="brandSecverifyType && (userInfo.userType == 2 || userInfo.userType == 1)">
				{{ verifyTypeStr ? verifyTypeStr : "暂无" }}
				<el-button
					type="text"
					@click="changeMFA(userInfo.secverifyType)"
					>修改验证方式</el-button
				>
				<modifyMFA ref="modifyMFA" />
			</el-form-item>
			<el-form-item label="ppn账号:">
				{{ ppnUsername }}
				<el-button type="text" @click="changePpnUsernamee">修改</el-button>
			</el-form-item>
		</el-form>

		<Verify ref="Verify" @onSubmit="verifyHandler" />
		<EditPass ref="EditPass"/>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import { getUserSave } from "@/api/user";
import Verify from "@/components/MFA/Verify";
import modifyMFA from "./components/modifyMFA";
import modifyPhone from "./components/modifyPhone";
import modifyEmail from "./components/modifyEmail";
import EditPass from "./components/EditPass";

export default {
	components: {
		Verify,
		modifyMFA,
		modifyPhone,
		modifyEmail,
		EditPass
	},
	data() {
		return {
			userInfoForm: {
				// name: '',
				// email: '',
				// mobile: ''
				account: "",
				agentCode: "",
				bossId: "",
				brandIdentify: "",
				contactInfo: "",
				createBy: "",
				createTime: "",
				email: "",
				headImg: "",
				isDeleted: false,
				menuList: [],
				nickname: "",
				password: "",
				state: "0",
				tsAccount: "",
				userId: "",
				userSite: "",
				userType: "",
				worktimeType: "",
			}
		};
	},
	computed: {
		...mapGetters(["userInfo"]),
		needMFA() {
			return this.userInfo;
		},
		nickName() {
			return this.userInfo.nickname;
		},
		ppnUsername() {
			return this.userInfo.ppnUsername;
		},
		phoneNumber() {
			return this.userInfo.contactInfo;
		},
		email() {
			return this. userInfo.email;
		},
		verifyTypeStr() {
			let secverifyTypeString = this.userInfo?.secverifyType ?? "";
			if (secverifyTypeString) {
				let secverifyArr = secverifyTypeString.split(",");
				return secverifyArr.filter(item => {
					return this.userInfo.brandSecverifyType.includes(item);
				}).join(",");
			}
			return this.userInfo?.secverifyType ?? "";
		},
		brandSecverifyType() {
			return this.userInfo.brandSecverifyType
		}
	},
	mounted() {
		console.log(`this.userInfo`, this.userInfo);
		this.userInfoForm = this.userInfo;
		this.userInfoForm.nickname = decodeURI(this.userInfo.nickname);
	},
	methods: {
		bindPhone() {
			this.changeTarget = "phone";
			this.openVerifier();
		},
		bindEmail() {
			this.changeTarget = "email";
			this.openVerifier();
		},
		changeMFA() {
			this.changeTarget = "changeMFA";
			if (!this.userInfo.contactInfo && !this.userInfo.email) {
				this.$message.success("请先绑手机或邮箱");
				return;
			}
			this.openVerifier();
		},
		openVerifier() {
			this.$refs.Verify.open({
				phoneNumber: this.userInfo.contactInfo,
				email: this.userInfo.email,
				verifySendApi: this.$api.secverifySend,
				operation: "verify",
			});
		},
		// 校验提交事件
		verifyHandler(data, fCloseVerify) {
			console.log(data);
			let _data = {}
			if (data.type === "password") {
				_data.password = data.code;
			} else {
				_data = this.filterCheckData(data);
			}
			this.$api
				.updateSecverifyCheck({
					..._data
				})
				.then((response) => {
					if (response.errcode != 0) return;
					if (response.data.flag === "false") {
						this.$message.error("验证码错误");
						return;
					}
					console.log(response);
					fCloseVerify();
					switch (this.changeTarget) {
						case "phone":
							this.$refs.modifyPhone.open( {
								bit: response.data.bit,
								key: response.data.key,
								verifySendApi:
									this.$api.commonUpdateContactSecverifysend,
							});
							break;
						case "email":
							this.$refs.modifyEmail.open( {
								bit: response.data.bit,
								key: response.data.key,
								verifySendApi:
									this.$api.commonUpdateContactSecverifysend,
							});
							break;
						case "changeMFA":
							this.$refs.modifyMFA.open({
								bit: response.data.bit,
								key: response.data.key
							});
							break;
						default:
							return;
					}
				});
		},
		// 过滤验证接口请求据
		filterCheckData(data) {
			const rs = {};
			rs.types = [data.type];
			rs.code = data.code;
			rs.bit = data.bit;
			rs.key = data.key;
			if (this.changeTarget === "phone") {
				if (!this.userInfo.contactInfo) {
					rs.contactInfo = data.phoneNumber;
				}
			} else if (this.changeTarget === "email") {
				if (!this.userInfo.email) {
					rs.email = data.email;
				}
			}
			return rs;
		},
		getUserTypeName(typeVal) {
			let typeName = ["普通用户", "超级管理员", "品牌管理员"];
			return typeName[parseInt(typeVal)];
		},
		changePwd(){
			this.$refs.EditPass.open();
		},
		changePpnUsernamee(value) {
			this.$prompt("请输入ppn账号", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				inputValidator: (value) => {
					return true;
				},
			})
				.then(({ value }) => {
					this.onSubmit1({
						ppnUsername: value,
					});
				})
				.catch(() => {
				});
		},
		changeNickName(value) {
			this.$prompt("请输入新昵称", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				inputValidator: (value) => {
					if (!value) {
						return "昵称不能为空";
					} else {
						return true;
					}
				},
			})
				.then(({ value }) => {
					this.onSubmit({
						nickname: value,
					});
				})
				.catch(() => {
				});
		},

		onSubmit(data) {
			const { nickname } = data;
			getUserSave("update", {
				...this.userInfoForm,
				nickname,
			}).then((res) => {
				let code = res.errcode;
				if (code == 0) {
					this.$message.success(res.errmsg);
				}
				this.$store.dispatch("user/getInfo").then((response) => {
					});
			});
		},
		onSubmit1(data) {
			const { ppnUsername } = data;
			getUserSave("update", {
				...this.userInfoForm,
				ppnUsername,
			}).then((res) => {
				let code = res.errcode;
				if (code == 0) {
					this.$message.success(res.errmsg);
				}
				this.$store.dispatch("user/getInfo").then((response) => {
					});
			});
		},
	},
	created() {},
};
</script>
<style scoped>
</style>